import {ref} from 'vue';
import {Ref} from '@vue/reactivity';
import {Geolocation} from "@/models/GeolocationModel";
import {configuration} from "@/composables/ConfigurationComposition";

export class GeolocationComposition {
    private _isAutocompleteLoading: Ref<boolean> = ref(false);
    public _autocompleteSuggestList: Ref<Map<string, Geolocation[]>> = ref(new Map<'', []>());
    private _lastSubmitResult: Ref<Geolocation | null> = ref(null);
    private _lastUpdateResult: Ref<Geolocation[]> = ref([]);
    private _formattedSearch: Ref<string> = ref('');
    private _unformattedSearch: Ref<string> = ref('');
    private _position: Ref<{ lat: number, lng: number }> = ref({
        lat: configuration.defaultLocation.lat,
        lng: configuration.defaultLocation.lng
    });
    private _country: Ref<string> = ref(configuration.defaultCountry);

    constructor() {
    }

    get isAutocompleteLoading(): boolean {
        return this._isAutocompleteLoading.value;
    }

    set isAutocompleteLoading(value: boolean) {
        this._isAutocompleteLoading.value = value;
    }

    get autocompleteSuggestList(): Map<string, Geolocation[]> {
        return this._autocompleteSuggestList.value;
    }

    addToAutocompleteSuggestList(search: string, list: Geolocation[]) {
        if (this.autocompleteSuggestList.has(search) === false) {
            this.autocompleteSuggestList.set(search, list);
        }
    }

    get lastSubmitResult(): Geolocation | null {
        return this._lastSubmitResult.value;
    }

    set lastSubmitResult(value: Geolocation | null) {
        this._lastSubmitResult.value = value;
    }

    get lastUpdateResult(): Geolocation[] {
        return this._lastUpdateResult.value;
    }

    set lastUpdateResult(value: Geolocation[]) {
        this._lastUpdateResult.value = value;
    }

    get formattedSearch(): string {
        return this._formattedSearch.value;
    }

    set formattedSearch(value: string) {
        this._formattedSearch.value = value;
    }

    get unformattedSearch(): string {
        return this._unformattedSearch.value;
    }

    set unformattedSearch(value: string) {
        this._unformattedSearch.value = value;
    }

    get position(): { lat: number; lng: number } {
        return this._position.value;
    }

    get positionHash(): string {
        return `${this.position.lat}-${this.position.lng}`
    }

    set position(value: { lat: number; lng: number }) {
        this._position.value = value;
    }

    get country(): string {
        return this._country.value;
    }

    set country(value: string) {
        this._country.value = value;
    }

    beginAutocompleteLoading() {
        this.isAutocompleteLoading = true;
    }

    endAutocompleteLoading() {
        this.isAutocompleteLoading = false;
    }

    resetPosition() {
        this.country = configuration.defaultCountry;

        this.position = {
            lat: configuration.defaultLocation.lat,
            lng: configuration.defaultLocation.lng
        };
    }
}

export const useGeolocationComposition = new GeolocationComposition();
